import { render, staticRenderFns } from "./messaging.vue?vue&type=template&id=376b0af3&scoped=true"
import script from "./messaging.vue?vue&type=script&lang=js"
export * from "./messaging.vue?vue&type=script&lang=js"
import style0 from "./messaging.vue?vue&type=style&index=0&id=376b0af3&prod&lang=css"
import style1 from "./messaging.vue?vue&type=style&index=1&id=376b0af3&prod&scoped=true&lang=css"
import style2 from "./messaging.vue?vue&type=style&index=2&id=376b0af3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b0af3",
  null
  
)

export default component.exports